import api from "./api";

const BASE_ENDPOINT = '/cache';

function cleanCache() {
    return api.delete(`${BASE_ENDPOINT}/clear`);
}

const CacheApiService = {
    cleanCache
}

export default CacheApiService;